module.exports = __webpack_public_path__ + "img/conjunctival-hyperemia-4.08aa5f3e.jpg";